// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__e9hEb","productName":"Table_productName__1U_iB"};